export default __webpack_public_path__ + "static/media/uploader-abbottNeo-problem-1.4c9ee6a8.png";